import { useEffect, useState } from "react";
import WaveSurfer from "wavesurfer.js";

export const useWavesurfer = (containerRef: any, options: any) => {
  const [wavesurfer, setWavesurfer] = useState<WaveSurfer>()

  useEffect(() => {
    if (!containerRef.current) return

    const ws = WaveSurfer.create({
      ...options,
      height: 80,
      barWidth: 2,
      barGap: 1,
      barRadius: 2,
      barHeight: 1,
      waveColor: 'rgba(255,255,255,0.6)',
      progressColor: '#c0392b',
      cursorColor: '#e74c3c',
      cursorWidth: 1,
      container: containerRef.current,
      hideScrollbar: true,
      autoScroll: true,
      normalize: true,
      fillParent: true,
    })

    setWavesurfer(ws)

    return () => {
      ws.destroy()
    }
  }, [options, containerRef])

  return wavesurfer
}
